/**
 * Infinite horizontal marquee — matches `website-standalone.html` testimonials block.
 */

const testimonials = [
  {
    quote:
      'Its really easy to use & save a enough to justify, a must use app',
    author: 'Rahul Sharma',
    company: 'Oculis Services Pvt Ltd',
  },
  {
    quote: 'Safe & Secure. Good app with all required features',
    author: 'Mr.Abhin Moudgil',
    company: 'MAK architech',
  },
  {
    quote:
      'When you are procuring multiple items from multiple vendors, its become very easy to negotiate through the Bid Master in a transparent yet effective manner.',
    author: 'Ashish Singh',
    company: 'Invert sugar',
  },
] as const;

const looped = [...testimonials, ...testimonials];

export function LandingTestimonialsSection() {
  return (
    <section className="py-20 bg-white border-t border-gray-100 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 mb-12">
        <h2 className="text-3xl md:text-4xl font-black text-slate-900 text-center tracking-tight">
          Trusted by Industry Leaders
        </h2>
      </div>

      <div className="relative flex overflow-x-hidden">
        <div className="landing-marquee-track flex w-max">
          {looped.map((t, i) => (
            <div
              key={`${t.author}-${i}`}
              className="mx-4 w-[min(100vw-2rem,400px)] shrink-0 md:w-[500px] bg-slate-50 p-8 md:p-10 rounded-[32px] border border-gray-100"
            >
              <div className="flex flex-col h-full min-h-[180px] justify-between">
                <p className="text-gray-600 font-medium italic mb-6 leading-relaxed">&quot;{t.quote}&quot;</p>
                <div>
                  <p className="text-sm font-black text-gray-900">{t.author}</p>
                  <p className="text-[10px] font-bold text-blue-600 uppercase tracking-widest mt-1">
                    {t.company}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
